import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en-IE',
        supportedLngs: ['en-IE', 'en-GB', 'fr-CH', 'de-CH', 'en-NG'],
        resources: {
            // TODO: (KM) Use json files
            'en-IE': {
                translation: {
                    welcome: 'Welcome',
                    totalPrice: 'Total Price',
                    taxIncluded: '(incl. tax)',
                    taxExcluded: '(excl. tax)',
                },
            },
            'fr-CH': {
                translation: {
                    welcome: 'Bienvenue',
                    totalPrice: 'Prix total',
                    taxIncluded: '(TTC)',
                    taxExcluded: '(HT)',
                },
            },
            'de-CH': {
                translation: {
                    welcome: 'Willkommen',
                    totalPrice: 'Gesamtpreis',
                    taxIncluded: '(inkl. MwSt)',
                    taxExcluded: '(zzgl. MwSt)',
                },
            },
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;

if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).i18n = i18n;
}
